export default __webpack_public_path__ + "static/media/master_level_avatar.34b2ccaa.svg";